export enum BetLabel {
    Live = "live",
    Prematch = "prematch",
}

export enum BetPlacement {
    SubMenu = "subMenu", //used on live detail - left navigation with all live matches
    Main = "main", //used on every detail - main block of content usually in the middle
    Ticket = "ticket", //used on ticket page/ticket widget
    Tips = "tips", //used on homepage - carousel
    Top = "top", //used on homepage - top bets
}

export enum BetCategory {
    IncreasedOdds = "increasedOdds",
    Popular = "popular",
    MyFavorite = "myFavorite", //used on prematch
    Favorite = "favorite", //used on live
    Streams = "streams",
    Sport = "sport",
}
